import RequestHandler from "./RequestHandler";

function NotificationsAPI() {
    const baseNotificationsAPI = "notifications";

    async function customToken() {
        try {
            const result = await RequestHandler.get(
                `${baseNotificationsAPI}/custom-token`
            );
            return result || [];
        } catch (error) {
            console.log(error);
        }
    }

    async function getLastSeen() {
        try {
            const result = await RequestHandler.get(
                `${baseNotificationsAPI}/last-seen`
            );
            return result || null;
        } catch (error) {
            console.log(error);
        }

        return null;
    }

    async function setLastSeen() {
        try {
            const result = await RequestHandler.post(
                `${baseNotificationsAPI}/last-seen`
            );
            return result || [];
        } catch (error) {
            console.log(error);
        }
    }

    return {
        customToken,
        getLastSeen,
        setLastSeen,
    };
}

export default NotificationsAPI();
